<template>
  <div>
    <v-dialog v-model="dialog" height="100%" width="1400">
      <v-card>
        <v-btn @click="dialog = false" class="mt-3" icon absolute right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title>
          {{ $t("duplicateProducts") }}
        </v-card-title>
        <v-card-text>
          <table-with-filter
            fixed-header
            :headers="headers"
            :is-filterable="false"
            :items="items"
            :loading="loading"
          >
            <template #header.id>
              <div class="d-flex justify-center align-center mb-4">
                <v-checkbox
                  :value="selectedAll"
                  hide-details
                  @change="selectAll"
                ></v-checkbox>
              </div>
            </template>
            <template #item.attrs="{ item: { attrs } }">
              <span v-if="attrs">{{ attrs.join(" && ") }}</span>
            </template>
            <template #item.id="{ item }">
              <v-checkbox
                multiple
                v-model="checked"
                :value="item.id"
              ></v-checkbox>
            </template>
          </table-with-filter>
          <div class="text-right pt-2">
            <v-btn
              :disabled="checked.length === 0"
              @click="deleteDialog = true"
              class="mr-2"
              color="error"
              >{{ $t("delete") }}</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <warning-dialog @apply="onDelete" v-model="deleteDialog"></warning-dialog>
  </div>
</template>

<script>
import TableWithFilter from "@/components/ui/table/TableWithFilter.vue";
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";

export default {
  name: "ProductDialog",
  components: {
    WarningDialog,
    TableWithFilter,
  },
  data() {
    return {
      deleteDialog: false,
      dialog: false,
      loading: false,
      items: [],
      checked: [],
    };
  },

  methods: {
    async onDelete() {
      this.showLoading();
      const checked = this.checked;
      try {
        await this.$http.delete("product/delete-multiple", {
          data: checked,
        });
        this.checked = [];
        this.items = this.items.filter((item) => {
          return !checked.includes(item.id);
        });
        this.setSuccess({ text: this.$t("successfullyDeleted") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getProducts(productName) {
      this.loading = true;
      try {
        const {
          data: { data },
        } = await this.$http.get("product/find-duplicate", {
          params: { name: productName },
        });
        this.items = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    selectAll(val) {
      if (val) {
        this.checked = this.items.map((item) => item.id);
      } else {
        this.checked = [];
      }
    },
    openDialog(productName) {
      this.dialog = true;
      this.getProducts(productName);
    },
    selectedAll() {
      return this.items.length === this.checked.length;
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.items = [];
        this.checked = [];
      }
    },
  },
  computed: {
    headers() {
      return [
        { text: "", value: "id" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("group"), value: "group_name" },
        { text: this.$t("category"), value: "type_name" },
        { text: this.$t("attributes"), value: "attrs" },
      ];
    },
  },
};
</script>
